import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import Header from '../../components/Header'
import hero from '../../images/our-mission__hero.jpg'
import img01 from '../../images/our-mission-1.jpg'
import img02 from '../../images/our-mission-2.jpg'
import img03 from '../../images/our-mission-3.jpg'

const Page = () => (
  <Fragment>
    <Helmet
      title="Our Mission | Who We Are"
      // meta={[{ name: 'description', content: '' }]}
    />
    <Header hero={hero}>
      <h1 className="t-hero">Our Mission</h1>
    </Header>
    <main id="content">
      <div className="c-golden t-context--light">
        <div className="c-golden__content c-golden__wide">
          <ul className="c-breadcrumbs mb30">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/who-we-are">Who We Are</Link>
            </li>
            <li>
              <Link to="/who-we-are/our-mission" activeClassName="is-active">
                Our Mission
              </Link>
            </li>
          </ul>
          <div className="c-golden__text">
            <div className="c-golden__text-col">
              <p className="t-p t-p--big t-p-light">
                As a professional and dedicated team, we are committed to
                provide unsurpassed service at competitive rates; to be a leader
                in our industry; and to make a difference for a better world by
                helping others through our success.
              </p>
            </div>
          </div>
          <div className="c-golden__next-page">
            <Link to="/who-we-are/why-ati" className="c-btn t-link mt30">
              Why ATI &nbsp;&#9654;
            </Link>
          </div>
        </div>
        <div className="c-golden__images c-golden__short min-laptop">
          <div style={{ width: '50%', height: '100%' }}>
            <img src={img01} alt="" style={{ width: '100%', height: '50%' }} />
            <img src={img03} alt="" style={{ width: '100%', height: '50%' }} />
          </div>
          <img src={img02} alt="" style={{ width: '50%', height: '100%' }} />
        </div>
      </div>
    </main>
  </Fragment>
)

export default Page



// WEBPACK FOOTER //
// ./src/pages/who-we-are/our-mission.js